export default {
  setVendedor(state, payload) {
    state.vendedor = payload
  },

  setEmpresa(state, payload) {
    state.empresa = payload
  },

  setGrupo(state, payload) {
    state.grupo = payload
  },

  setMidia(state, payload) {
    state.midia = payload
  }
}
